import useRequest from './useRequest';

export default { useRequest };
